import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider"

interface BuscarEstruturasPorModuloRequest {
  moduloId: number
  potencia: number
  regioesId: number[]
  segmento?: string
}

const componenteProvider = new ComponenteProvider()

export const buscarEstruturasPorModulo = async ({ moduloId, potencia, regioesId, segmento = "on" }: BuscarEstruturasPorModuloRequest) => {
  const estruturasResponse = await componenteProvider.buscarEstruturasPorModuloId(moduloId, {
    potencia: String(potencia),
    segmento: segmento,
    regiao_id: regioesId,
  })

  const ativos = estruturasResponse.filter(item => item.status)
  
  return {
    ativos: ativos,
    todos: estruturasResponse,
    retrato: ativos.filter(item => {
      return item.grupos.some(grupo => 
        ['retrato', 'ambos', null].includes(grupo.posicao) &&
        [segmento, 'todos', null].includes(grupo.segmento) &&
        grupo.id === item.estruturas_grupo_id
      )
    }),
    paisagem: ativos.filter(item => {
      return item.grupos.some(grupo => 
        ['paisagem', 'ambos', null].includes(grupo.posicao) && 
        [segmento, 'todos', null].includes(grupo.segmento) &&
        grupo.id === item.estruturas_grupo_id
      )
    })
  }
}